export default __webpack_public_path__ + "static/media/868.9a87a921.png";